import { useState, useEffect } from 'react';
import homePageService from '../../../services/homePageService';
import './AdminSlider.css';

const AdminBoxes = () => {
  const [boxData, setBoxData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [editingBox, setEditingBox] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [newBox, setNewBox] = useState({ imagePreview: '', url: '' });

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const content = await homePageService.getHomePageContent();
      if (content.boxData) setBoxData(content.boxData);
    } catch { setError('Veriler yüklenemedi.'); }
    finally { setLoading(false); }
  };

  const save = async (data) => {
    try {
      await homePageService.updateHomePageContent({ boxData: data });
      setBoxData(data);
      return true;
    } catch { setError('Kaydetme başarısız.'); return false; }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (!newBox.imagePreview) { setError('Resim seçin.'); return; }
    const maxId = boxData.length > 0 ? Math.max(...boxData.map(b => b.id)) : 0;
    if (await save([...boxData, { id: maxId + 1, image: newBox.imagePreview, url: newBox.url || '#' }])) {
      setSuccess('Kutu eklendi.');
      setShowAddForm(false);
      setNewBox({ imagePreview: '', url: '' });
      fetchData();
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Kutuyu silmek istediğinizden emin misiniz?')) return;
    setError(''); setSuccess('');
    if (await save(boxData.filter(b => b.id !== id))) setSuccess('Kutu silindi.');
  };

  const handleSaveEdit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    const data = boxData.map(b => b.id === editingBox.id ? { id: b.id, image: editingBox.newImage || b.image, url: editingBox.url } : b);
    if (await save(data)) { setSuccess('Kutu güncellendi.'); setEditingBox(null); fetchData(); }
  };

  const handleFile = (e, target) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      if (target === 'new') setNewBox({ ...newBox, imagePreview: reader.result });
      else setEditingBox({ ...editingBox, newImage: reader.result });
    };
    reader.readAsDataURL(file);
  };

  if (loading) return <div className="admin-slider-empty">Yükleniyor...</div>;

  return (
    <div className="admin-slider">
      {success && <div className="admin-slider-success">{success}</div>}
      {error && <div className="admin-slider-error">{error}</div>}

      <div className="admin-slider-card">
        <div className="admin-slider-header">
          <h3>Kutucuklar ({boxData.length} kutu)</h3>
          <button className="admin-slider-add-btn" onClick={() => { setShowAddForm(!showAddForm); setEditingBox(null); }}>+ Yeni Kutu</button>
        </div>

        {showAddForm && (
          <form className="admin-slider-form" onSubmit={handleAdd}>
            <h4>Yeni Kutu Ekle</h4>
            <div className="admin-slider-form-group">
              <label>Resim</label>
              <input type="file" accept="image/*" onChange={(e) => handleFile(e, 'new')} />
              {newBox.imagePreview && <img src={newBox.imagePreview} alt="Önizleme" className="admin-slider-preview" />}
            </div>
            <div className="admin-slider-form-group">
              <label>URL</label>
              <input type="text" value={newBox.url} onChange={(e) => setNewBox({ ...newBox, url: e.target.value })} placeholder="/cizelge/..." />
            </div>
            <div className="admin-slider-form-actions">
              <button type="submit" className="admin-slider-btn-save">Ekle</button>
              <button type="button" className="admin-slider-btn-cancel" onClick={() => setShowAddForm(false)}>İptal</button>
            </div>
          </form>
        )}

        {editingBox && (
          <form className="admin-slider-form" onSubmit={handleSaveEdit}>
            <h4>Kutu Düzenle</h4>
            <div className="admin-slider-form-group">
              <label>Resim</label>
              <img src={editingBox.newImage || editingBox.image} alt="Mevcut" className="admin-slider-preview" />
              <input type="file" accept="image/*" onChange={(e) => handleFile(e, 'edit')} style={{ marginTop: '0.5rem' }} />
            </div>
            <div className="admin-slider-form-group">
              <label>URL</label>
              <input type="text" value={editingBox.url} onChange={(e) => setEditingBox({ ...editingBox, url: e.target.value })} />
            </div>
            <div className="admin-slider-form-actions">
              <button type="submit" className="admin-slider-btn-save">Kaydet</button>
              <button type="button" className="admin-slider-btn-cancel" onClick={() => setEditingBox(null)}>İptal</button>
            </div>
          </form>
        )}

        {boxData.length > 0 ? (
          <div className="admin-slider-grid">
            {boxData.map((box, i) => (
              <div key={box.id} className="admin-slider-item">
                <img src={box.image} alt={`Kutu ${i + 1}`} />
                <div className="admin-slider-item-info">
                  <p className="admin-slider-item-url">URL: {box.url}</p>
                  <div className="admin-slider-item-actions">
                    <button className="admin-slider-btn-edit" onClick={() => { setEditingBox({ ...box, newImage: null }); setShowAddForm(false); }}>Düzenle</button>
                    <button className="admin-slider-btn-delete" onClick={() => handleDelete(box.id)}>Sil</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : <div className="admin-slider-empty">Henüz kutu yok.</div>}
      </div>
    </div>
  );
};

export default AdminBoxes;
